import { trigger } from '@angular/animations';
import { isPlatformServer, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, HostListener, Inject, Input, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { moveAndFadeDownIf } from 'src/app/animations/move-and-fade-down.if.animation';
import { BrowserService } from 'src/app/services/browser.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ButtonDirective } from '../../directives/button.directive';
import { ResizeDirective } from '../../directives/resize.directive';
import { WebsiteMobileMenuComponent } from '../../menus/website-mobile-menu/website-mobile-menu.component';
import { HeaderComponent } from '../header/header.component';
import { SvgComponent } from '../svg/svg.component';
import { WebsiteDesktopMenuComponent } from '../website-desktop-menu/website-desktop-menu.component';

@Component({
  selector: 'app-website-header',
  templateUrl: './website-header.component.html',
  styleUrls: ['./website-header.component.scss'],
  animations: [trigger('fixedDesktopHeader', moveAndFadeDownIf)],
  standalone: true,
  imports: [
    ResizeDirective,
    HeaderComponent,
    RouterLink,
    WebsiteDesktopMenuComponent,
    NgIf,
    ButtonDirective,
    SvgComponent,
    NgTemplateOutlet,
  ],
})
export class WebsiteHeaderComponent {
  @Input() color: 'dark' | 'blue';
  @Input() hideNav = false;
  @Input() hideNormalCta = false;
  scrolled: boolean;
  headerOutOfView: boolean;
  loggedIn = false;

  @HostListener('window:resize', ['$event']) winResize() {
    this.calcBackgroundMode();
  }
  @HostListener('window:scroll', ['$event']) docScroll() {
    this.calcBackgroundMode();
  }

  constructor(
    private dialog: DialogService,
    private browserService: BrowserService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.calcBackgroundMode();
    if (isPlatformServer(this.platformId)) return;
    this.loggedIn = this.browserService.getCookies()?.['picflow-loggedin'] === 'true';
  }

  private calcBackgroundMode() {
    if (isPlatformServer(this.platformId)) return (this.scrolled = false);
    if (!window.document.scrollingElement) return;
    this.scrolled = window.document.scrollingElement.scrollTop > 10;
    this.headerOutOfView = window.document.scrollingElement.scrollTop > 72;
  }

  openMobileMenu() {
    this.dialog.open(WebsiteMobileMenuComponent, {});
  }
}
